import { get } from 'lodash';
import { INTEGRATIONS_BASE_URL, INTERNAL_BASE_URL } from '../constants';
import { getDataFromToken } from './';

export function buildApiUrl(token, companyId, employeeId) {
  const { tenantId = get(window, 'asure.appSettings.tenantId') } = getDataFromToken(token);
  if (tenantId && companyId) {
    let url = `${INTEGRATIONS_BASE_URL}/tenants/${tenantId}/companies/${companyId}`;
    if (employeeId >= 0) {
      url += `/employees/${employeeId}`;
    }
    return `${url}/esignatures`;
  }
  if (!tenantId) throw new Error('Must provide a tenantId.');
  if (!companyId) throw new Error('Must specify a company.');
  return null;
}

export function buildInternalApiUrl(token, companyId = null, employeeId = null) {
  const { tenantId = get(window, 'asure.appSettings.tenantId') } = getDataFromToken(token);
  if (tenantId) {
    let url = `${INTERNAL_BASE_URL}/tenants/${tenantId}`;
    if (companyId) {
      url = `${url}/companies/${companyId}`;
    }
    if (employeeId) {
      url = `${url}/employees/${employeeId}`;
    }
    return url;
  }

  throw new Error('Must provide a tenantId.');
}


export function buildTenantApiUri(token) {
  const { tenantId = get(window, 'asure.appSettings.tenantId') } = getDataFromToken(token);
  if (tenantId) {
    return `${INTEGRATIONS_BASE_URL}/tenants/${tenantId}`;
  }
  throw new Error('Must provide a tenantId.');
}



// WEBPACK FOOTER //
// ./src/helpers/buildApiUrl.js